"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var LanguageOverrides = (function () {
    function LanguageOverrides(createUi, customLabels, block, labelService, simpleDropdownFactory, telemetry) {
        var _a;
        var defaultLabelSets = [labelService.getDefaultFields()];
        var getLabelSets = function () {
            var _a;
            if (((_a = labelService.getActiveLabelSets()) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                return lodash_1.default.concat(labelService.getActiveLabelSets(), defaultLabelSets);
            }
            else {
                return defaultLabelSets;
            }
        };
        var getLabelSet = function (id) {
            if (id != null) {
                return lodash_1.default.find(labelSets, { id: id });
            }
            else {
                return lodash_1.default.last(labelSets);
            }
        };
        var labelSets = getLabelSets();
        var refreshLabelSets = function () {
            labelSets.splice(0, labelSets.length);
            return Array.from(getLabelSets()).map(function (labelSet) { return labelSets.push(labelSet); });
        };
        this.menuVisible = false;
        var currentLabelSetId = ((_a = block.settings) === null || _a === void 0 ? void 0 : _a.labelSetId) || null;
        this.ui = createUi(require("./LanguageOverrides.html"), {
            overrideDropdown: simpleDropdownFactory.create(labelSets, getLabelSet(currentLabelSetId), function (selected) {
                block.settings.labelSetId = currentLabelSetId = selected.id;
                var labelSetType = !!block.settings.labelSetId ? "custom" : "none";
                telemetry.track("Quote Block Label Set Applied", { quote_block_label_set_type: labelSetType }, { blockIntercom: true });
            }),
            editOverrides: function () {
                return customLabels.show(refreshLabelSets);
            },
        });
    }
    return LanguageOverrides;
}());
exports.default = LanguageOverrides;
